import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import { faPencilAlt, faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { getAxisUserProfile } from "../../actions/auth";
import { makeGetReplaceable } from "../../selectors/asset";
import { makeGetConfigValue } from "../../selectors/config";
import AssetType from "../../constants/assetTypes";
import { generateShortcutText } from "../../util/keyShortcutUtils";
import localize from "../../util/localizeUtils";
import SideBarButton from "../SideBar/SideBarButton";
import { SideBarInner } from "../../styled-components/SideBar";
import Settings from "../../settings";

const Mousetrap = window.Mousetrap;

const ActionSideBarContainer = styled(SideBarInner)`
  justify-content: center;
`;

class Footer extends Component {
  constructor(props) {
    super(props);
    if (!props.axisServicesLoaded) {
      props.getAxisUserProfile();
    }
  }
  componentDidMount = () => {
    this.bindShortcuts();
  };

  componentWillUnmount = () => {
    this.unbindShortcuts();
  };

  getComposeButtonLabel() {
    return generateShortcutText(
      this.props.replaceableType === "image"
        ? localize("composeImageButton")
        : localize("composeMovieButton"),
      this.props.isModifierActive
    );
  }

  getOrderButtonLabel() {
    return generateShortcutText(
      this.props.replaceableType === "image"
        ? localize("orderImageButton")
        : localize("orderMovieButton"),
      this.props.isModifierActive
    );
  }

  bindShortcuts = () => {
    const { openCompose, openOrder } = this.props.shortcuts;
    const { openBuildGraphicDialog, openOrderGraphicDialog } = this.props;
    Mousetrap.bindGlobal(openCompose, () => {
      const {
        buildGraphicButtonVisible,
        replaceableType,
        showComposeImages,
        showComposeMovies,
      } = this.props;
      if (
        buildGraphicButtonVisible &&
        ((replaceableType === "image" && showComposeImages) ||
          (replaceableType === "video" &&
            showComposeMovies &&
            Settings.enableClipper))
      ) {
        openBuildGraphicDialog();
      }
    });
    Mousetrap.bindGlobal(openOrder, () => {
      if (this.props.showOrderButton) {
        openOrderGraphicDialog();
      }
    });
  };

  unbindShortcuts = () => {
    const { openCompose, openOrder } = this.props.shortcuts;
    Mousetrap.bindGlobal(openCompose);
    Mousetrap.bindGlobal(openOrder);
  };

  renderComposeButton() {
    const {
      openBuildGraphicDialog,
      buildGraphicButtonVisible,
      showComposeImages,
      showComposeMovies,
      replaceableType,
    } = this.props;
    if (
      buildGraphicButtonVisible &&
      ((replaceableType === "image" && showComposeImages) ||
        (replaceableType === "video" && showComposeMovies))
    ) {
      return (
        <SideBarButton
          onClick={openBuildGraphicDialog}
          text={this.getComposeButtonLabel()}
          image={faPencilAlt}
        />
      );
    }
  }
  renderOrderButton() {
    if (this.props.showOrderButton) {
      return (
        <SideBarButton
          onClick={this.props.openOrderGraphicDialog}
          text={this.getOrderButtonLabel()}
          image={faShoppingCart}
        />
      );
    }
  }
  render() {
    return (
      <ActionSideBarContainer>
        {this.renderComposeButton()}
        {this.renderOrderButton()}
      </ActionSideBarContainer>
    );
  }
}

Footer.defaultProps = {
  openOrderGraphicDialog: () => {},
  openBuildGraphicDialog: () => {},
  buildGraphicButtonVisible: false,
  replaceableType: "",
  showOrderButton: false,
  showComposeMovies: false,
  showComposeImages: true,
};

Footer.propTypes = {
  axisServicesLoaded: PropTypes.bool.isRequired,
  getAxisUserProfile: PropTypes.func.isRequired,
  openOrderGraphicDialog: PropTypes.func,
  openBuildGraphicDialog: PropTypes.func,
  buildGraphicButtonVisible: PropTypes.bool,
  replaceableType: PropTypes.string,
  showOrderButton: PropTypes.bool,
  showComposeImages: PropTypes.bool,
  showComposeMovies: PropTypes.bool,
  shortcuts: PropTypes.shape({
    openCompose: PropTypes.arrayOf(PropTypes.string),
    openOrder: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  isModifierActive: PropTypes.bool.isRequired,
};

const makeMapStateToProps = () => {
  const getReplaceable = makeGetReplaceable();
  const getConfigValue = makeGetConfigValue();

  const mapStateToProps = (state) => {
    if (state.asset.selectedReplaceableId) {
      const { properties, type } = getReplaceable(
        state,
        state.asset.selectedReplaceableId
      );
      const { canCreateOrders } = state.auth.axisUserProfile;
      const isAxisReplaceable =
        properties.axisTemplate != null ||
        properties.axisStyle != null ||
        properties["axis template id"] != null;
      const isMediaFormatLinked =
        properties.axisOrderMediaFormat != null &&
        properties.axisOrderMediaFormat !== "";
      const isVidigoTemplate = state.assets.assetType === AssetType.AUTOMATION;
      const axisServicesLoaded = state.auth.axisUserProfile.loaded;
      return {
        axisServicesLoaded,
        buildGraphicButtonVisible:
          isAxisReplaceable ||
          (isVidigoTemplate && Settings.enableClipper) ||
          type.toLowerCase() !== "video",
        replaceableType: type.toLowerCase(),
        showOrderButton:
          canCreateOrders &&
          isMediaFormatLinked &&
          getConfigValue(state, "userConfig", "orderDisplay", "show") ===
            "show",
        showComposeImages:
          getConfigValue(
            state,
            "userConfig",
            "composeImagesDisplay",
            "show"
          ) === "show",
        showComposeMovies:
          getConfigValue(
            state,
            "userConfig",
            "composeMoviesDisplay",
            "hide"
          ) === "show",
        shortcuts: state.keyShortcuts.shortcuts,
        isModifierActive: state.keyShortcuts.isModifierActive,
      };
    }
    return {
      shortcuts: state.keyShortcuts.shortcuts,
      isModifierActive: state.keyShortcuts.isModifierActive,
    };
  };

  return mapStateToProps;
};

const mapActionCreators = {
  getAxisUserProfile,
};

export default connect(makeMapStateToProps, mapActionCreators)(Footer);



// WEBPACK FOOTER //
// ./app/components/ContentSelection/ContentActionSideBar.js